<app-side-menu-content>
	<app-side-menu-group>
		<app-side-menu-group-title>{{"Fixiert" | translate : "fields-label-fixed"}}</app-side-menu-group-title>
		<app-side-menu-group-content class="overview-settings-menu__fields" cdkDropList [cdkDropListData]="fixedColumns()" (cdkDropListDropped)="rearrangeFields($event)">
				@for(column of fixedColumns(); track column.field){
					<div cdkDrag cdkDragBoundary=".overview-settings-menu__fields" cdkDragLockAxis="y" class="overview-settings-menu__field--draggable">
						<ogs-m3-icon prefix="fal" icon="grip-lines-vertical"/>
	     <app-overview-menu-field [header]="column" (visibilityClicked)="changeVisibility($event, column)" (fixedClicked)="changeFixed($event, column)"/>
					</div>
					}
		</app-side-menu-group-content>
	</app-side-menu-group>
	<app-side-menu-group>
		<app-side-menu-group-title>{{"Eingeblendet" | translate : "fields-label-visible"}}</app-side-menu-group-title>
		<app-side-menu-group-content class="overview-settings-menu__fields" cdkDropList [cdkDropListData]="visibleColumns()" (cdkDropListDropped)="rearrangeFields($event)">
				@for(column of visibleColumns(); track column.field){
					<div cdkDrag cdkDragBoundary=".overview-settings-menu__fields" cdkDragLockAxis="y" class="overview-settings-menu__field--draggable">
						<ogs-m3-icon prefix="fal" icon="grip-lines-vertical"/>
	     <app-overview-menu-field [header]="column" (visibilityClicked)="changeVisibility($event, column)" (fixedClicked)="changeFixed($event, column)"/>
					</div>
					}
		</app-side-menu-group-content>
	</app-side-menu-group>
	<app-side-menu-group>
		<app-side-menu-group-title>{{"Ausgeblendet" | translate : "fields-label-hidden"}}</app-side-menu-group-title>
		<app-side-menu-group-content class="overview-settings-menu__fields" cdkDropList [cdkDropListData]="hiddenColumns()" (cdkDropListDropped)="rearrangeFields($event)">
				@for(column of hiddenColumns(); track column.field){
					<div cdkDrag cdkDragLockAxis="y" cdkDragBoundary=".overview-settings-menu__fields" class="overview-settings-menu__field--draggable">
						<ogs-m3-icon prefix="fal" icon="grip-lines-vertical"/>
	     <app-overview-menu-field [header]="column" (visibilityClicked)="changeVisibility($event, column)" (fixedClicked)="changeFixed
		 ($event, column)"/>
					</div>
				}
		</app-side-menu-group-content>
	</app-side-menu-group>
</app-side-menu-content>
